import { QuotingRole } from 'Users/models/User/Quoting/QuotingRole';
import { QuotingAdminUserType } from './Quoting/QuotingAdminUserType';

export class UndeterminedQuotingUserType {
  public readonly key = 'UndeterminedQuotingUserType';
  public readonly quotingRole = QuotingRole.Undetermined;
}

export class InvalidQuotingUserType {
  public readonly key = 'InvalidQuotingUserType';
  public readonly value = new UndeterminedQuotingUserType();
}

export class ValidQuotingUserType {
  public readonly key = 'ValidQuotingUserType';
  constructor(public readonly value: QuotingAdminUserType) {}
}
export type QuotingUserTypeValue = ValidQuotingUserType['value'] | InvalidQuotingUserType['value'];

export const isQuotingAdminUserType = (userType: QuotingUserType) =>
  userType.key === 'ValidQuotingUserType' || userType.key === 'InvalidQuotingUserType';

export type QuotingUserType = ValidQuotingUserType | InvalidQuotingUserType;

type QuotingUserTypeOptions<TReturn> = {
  Undetermined: () => TReturn;
  Admin: (adminUserType: QuotingAdminUserType) => TReturn;
};

export const matchQuotingUserType = <TReturn>(
  quotingUserType: ValidQuotingUserType['value'] | InvalidQuotingUserType['value'],
  options: QuotingUserTypeOptions<TReturn>
): TReturn => {
  switch (quotingUserType.key) {
    case 'UndeterminedQuotingUserType':
      return options.Undetermined();
    case 'QuotingAdminUserType':
      return options.Admin(quotingUserType);
  }
};
